import { Link as RouterLink, useSearchParams, useNavigate } from 'react-router-dom';
// material
import { styled } from '@material-ui/core/styles';
import { Card, Stack, Link, Container, Typography } from '@material-ui/core';
// layouts
import { useTranslation } from 'react-i18next';
import AuthLayout from '../layouts/AuthLayout';
// components
import Page from '../components/Page';
import { MHidden } from '../components/@material-extend';
import ConfirmSignUpForm from '../components/ConfirmSignUpForm';

// ----------------------------------------------------------------------

const RootStyle = styled(Page)(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex'
  }
}));

const SectionStyle = styled(Card)(({ theme }) => ({
  width: '100%',
  maxWidth: 464,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  margin: theme.spacing(2, 0, 2, 2)
}));

const ContentStyle = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  display: 'flex',
  minHeight: '100vh',
  flexDirection: 'column',
  justifyContent: 'center',
  padding: theme.spacing(12, 0)
}));

// ----------------------------------------------------------------------

export default function ConfirmSignUp() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const username = searchParams.get('username');

  const handleSubmitSuccess = () => {
    navigate({
      pathname: '/login',
      search: `?username=${username}`
    });
  };

  return (
    <RootStyle title={t('pages.confirm_signup')}>
      <AuthLayout>
        {t('confirm_signup.dont_have_account')} &nbsp;
        <Link underline="none" variant="subtitle2" component={RouterLink} to="/signup">
          {t('confirm_signup.get_started')}
        </Link>
      </AuthLayout>

      <MHidden width="mdDown">
        <SectionStyle>
          <Typography variant="h3" sx={{ px: 5, mt: 10, mb: 5 }}>
            {t('confirm_signup.almost_here')}
          </Typography>
          <img src="/static/illustrations/illustration_recommender.jpg" alt="login" />
        </SectionStyle>
      </MHidden>

      <Container maxWidth="sm">
        <ContentStyle>
          <Stack sx={{ mb: 5 }}>
            <Typography variant="h4" gutterBottom>
              {t('confirm_signup.confirm')}
            </Typography>
            <Typography sx={{ color: 'text.secondary' }}>
              {t('confirm_signup.enter_details')}
            </Typography>
          </Stack>

          <ConfirmSignUpForm
            defaultUsername={searchParams.get('username')}
            onSubmitSuccess={handleSubmitSuccess}
          />

          <MHidden width="smUp">
            <Typography variant="body2" align="center" sx={{ mt: 3 }}>
              {t('confirm_signup.dont_have_account')}&nbsp;
              <Link variant="subtitle2" component={RouterLink} to="register">
                {t('confirm_signup.get_started')}
              </Link>
            </Typography>
          </MHidden>
        </ContentStyle>
      </Container>
    </RootStyle>
  );
}
